module.exports = __webpack_public_path__ + "img/3.9.be429fe2.png";